app.service('contratService', ['$stateParams', '$state', function ($stateParams, $state) {


    /**
     * Retourne l'ID du contrat actuel
     * @returns int
     */
    this.getContratId = function () {
        return $stateParams.contrat_id;
    };

    /**
     * Retourne le slug du model du contrat actuel
     * @returns string
     */
    this.getContratSlug = function () {
        return $state.current.name.split('.')[2];
    };

    this.urlContratId = function (fct_name) {
        return '/contrat/' + this.getContratId() + '/' + fct_name;
    };

    this.urlContrat = function (fct_name) {
        return '/contrat/' + this.getContratId() + '/' + this.getContratSlug() + '/' + fct_name;
    };

    this.urlFeature = function (featureSlug, fct_name) {
        return this.urlContrat(featureSlug + '/' + fct_name);
    };

    /**
     * Permet de déterminer si nous sommes dans la feauture passé en parametre
     * @param featureSlug
     * @returns {boolean|*}
     */
    this.isInFeature = function (featureSlug) {
        return $state.includes('app.contrat.' + $state.current.name.split('.')[2] + '.' + featureSlug);
    };

    /**
     * Permet de rediriger lorsqu'on arrive sur la feature vers la vue par catégorie ou UI Grid selon les préférences de session ou le point d'entrée
     * @param featureSlug
     */
    this.preferenceDisplay = function (currentRoute, contratSlug, featureSlug) {
        if (currentRoute === 'app.contrat.' + contratSlug + '.' + featureSlug) {
            if (sessionStorage.getItem('prefShowByCategories') !== null) {
                if (sessionStorage.getItem('prefShowByCategories') == 'true') {
                    $state.go('app.contrat.' + contratSlug + '.' + featureSlug + '.global', $stateParams);
                } else {
                    $state.go('app.contrat.' + contratSlug + '.' + featureSlug + '.details', $stateParams);
                }
            } else {
                $state.go('app.contrat.' + contratSlug + '.' + featureSlug + '.global', $stateParams);
            }
        } else if (currentRoute === 'app.contrat.' + contratSlug + '.' + featureSlug + '.code') {
            $state.go('app.contrat.' + contratSlug + '.' + featureSlug + '.global', $stateParams);
        } else if (
            currentRoute === 'app.contrat.' + contratSlug + '.' + featureSlug + '.intervention' ||
            currentRoute === 'app.contrat.' + contratSlug + '.' + featureSlug + '.rapport') {
            $state.go('app.contrat.' + contratSlug + '.' + featureSlug + '.details', $stateParams);
        }
    };

    this.setPreferenceDisplay = function (pref) {
        sessionStorage.setItem('prefShowByCategories', pref);
    };

}]);
